import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchVehiclesMaintenance = () =>
  apiActionCreator({
    'endpoint': '/budgets/svfMaster',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLES_MAINTENANCE,
      ActionTypes.FETCHED_VEHICLES_MAINTENANCE,
      [ActionTypes.FETCHED_VEHICLES_MAINTENANCE_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const updateVehiclesMaintenance = (data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/budgets/svfMaster',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_VEHICLES_MAINTENANCE,
        [
          () => {
            dispatch(fetchVehiclesMaintenance());
            return {
              'type': ActionTypes.UPDATED_VEHICLES_MAINTENANCE,
            };
          },
          (response) => MessageActions.addMessageBoxInfo('Registro Actualizado'),
        ],
        [ActionTypes.UPDATED_VEHICLES_MAINTENANCE_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};
